import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const items = [{
  name: 'Tomo 1 — El Mapa del Alma',
  value: '$7 USD'
}, {
  name: 'Tomo 2 — Su Forma de Aprender',
  value: '$7 USD'
}, {
  name: 'Tomo 3 — Sus Emociones',
  value: '$7 USD'
}, {
  name: 'Tomo 4 — Su Forma de Comunicarse',
  value: '$7 USD'
}, {
  name: 'Tomo 5 — Crianza Sin Conflicto',
  value: '$7 USD'
}, {
  name: 'Tomo 6 — Conexión Profunda',
  value: '$7 USD'
}, {
  name: 'Bonus 1 — Guía de Emergencia',
  value: '$5 USD',
  isBonus: true
}, {
  name: 'Bonus 2 — Diccionario de Conductas',
  value: '$5 USD',
  isBonus: true
}, {
  name: 'Bonus 3 — Rituales de Conexión',
  value: '$5 USD',
  isBonus: true
}];
export function LimitedOfferSection() {
  return <section id="oferta-limitada" className="py-16 px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #3b0a1a 0%, #5c1a2a 40%, #3b0a1a 70%, #2a0715 100%)'
  }} data-id="element-118">
      {/* Animated decorative glows */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.15, 0.3, 0.15]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-0 left-1/4 w-96 h-96 bg-gold-300/20 rounded-full blur-3xl" data-id="element-119" />
      <motion.div animate={{
      scale: [1.2, 1, 1.2],
      opacity: [0.1, 0.25, 0.1]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute bottom-0 right-1/4 w-80 h-80 bg-dusty-rose-400/15 rounded-full blur-3xl" data-id="element-120" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-300/5 rounded-full blur-3xl" data-id="element-121" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-122">
        <FadeIn data-id="element-123">
          {/* Animated badge */}
          <div className="flex justify-center mb-4" data-id="element-124">
            <motion.span animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center gap-2 bg-gradient-to-r from-gold-300 via-gold-200 to-gold-300 text-burgundy-900 text-xs font-bold tracking-widest uppercase px-6 py-2.5 rounded-full shadow-lg border border-gold-400/50" data-id="element-125">
              🔥 Oferta por tiempo limitado 🔥
            </motion.span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-gold-300 text-center mb-2 drop-shadow-lg" data-id="element-126">
            Lo que estás recibiendo hoy
          </h2>
          <p className="text-center text-cream-200/60 text-sm mb-8" data-id="element-127">
            Todo esto incluido en una sola compra
          </p>

          {/* Card container with glass effect */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-gold-300/20 shadow-2xl overflow-hidden" data-id="element-128">
            <table className="w-full" data-id="element-129">
              <thead data-id="element-130">
                <tr className="border-b border-gold-300/20" data-id="element-131">
                  <th className="text-left py-3 px-5 text-[10px] font-bold text-gold-300/80 uppercase tracking-widest" data-id="element-132">
                    Qué incluye
                  </th>
                  <th className="text-right py-3 px-5 text-[10px] font-bold text-gold-300/80 uppercase tracking-widest" data-id="element-133">
                    Valor real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-134">
                {items.map((item, i) => <motion.tr key={i} initial={{
                opacity: 0,
                x: -15
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.06,
                duration: 0.4
              }} className={`border-b border-white/5 ${item.isBonus ? 'bg-gold-300/5' : ''}`} data-id="element-135">
                    <td className="py-3 px-5 text-sm text-cream-100" data-id="element-136">
                      {item.isBonus ? <span className="text-gold-300 mr-1.5" data-id="element-137">🎁</span> : <span className="text-dusty-rose-300 mr-1.5" data-id="element-138">📖</span>}
                      {item.name}
                    </td>
                    <td className="py-3 px-5 text-sm text-cream-200/70 text-right font-medium" data-id="element-139">
                      {item.value}
                    </td>
                  </motion.tr>)}

                {/* Total row */}
                <tr className="border-t-2 border-gold-300/20 bg-white/5" data-id="element-140">
                  <td className="py-4 px-5 text-sm font-bold text-cream-100" data-id="element-141">
                    VALOR TOTAL
                  </td>
                  <td className="py-4 px-5 text-base font-bold text-cream-200/60 text-right line-through decoration-dusty-rose-400 decoration-2" data-id="element-142">
                    $57 USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Price highlight */}
          <div className="text-center mt-10" data-id="element-143">
            <p className="text-sm text-cream-200/70 mb-3 uppercase tracking-wider" data-id="element-144">
              Hoy todo esto por solo
            </p>

            <div className="relative inline-block" data-id="element-145">
              {/* Glow behind price */}
              <motion.div animate={{
              scale: [1, 1.15, 1],
              opacity: [0.3, 0.6, 0.3]
            }} transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute inset-0 bg-gold-300/30 rounded-full blur-2xl scale-150" data-id="element-146" />
              <motion.div animate={{
              scale: [1, 1.04, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-147">
                <span className="text-7xl md:text-8xl font-bold text-gold-300 drop-shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-148">
                  $11
                </span>
                <span className="text-2xl md:text-3xl font-bold text-gold-200/80 ml-2 align-top mt-4 inline-block" data-id="element-149">
                  USD
                </span>
              </motion.div>
            </div>

            <p className="text-xs text-cream-200/60 mt-4 italic" data-id="element-150">
              💱 Pagarás en la moneda de tu país
            </p>
          </div>

          {/* CTA */}
          <div className="text-center mt-10 relative" data-id="element-151">
            {/* Button glow */}
            <motion.div animate={{
            scale: [1, 1.05, 1],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute inset-0 mx-auto max-w-md bg-gold-300/30 rounded-full blur-xl" data-id="element-152" />
            <motion.a href="https://pay.hotmart.com/S104936734A?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="relative inline-flex flex-col items-center bg-gradient-to-r from-gold-300 via-gold-200 to-gold-300 text-burgundy-900 font-bold py-4 px-10 rounded-full shadow-2xl hover:shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-all w-full max-w-md border border-gold-400/50 text-center" data-id="element-153">
              <span className="text-sm md:text-base tracking-wide" data-id="element-154">
                🌟 QUIERO MI COLECCIÓN COMPLETA
              </span>
              <span className="text-[9px] font-normal mt-0.5 opacity-70" data-id="element-155">
                💱 Pagarás en la moneda de tu país
              </span>
            </motion.a>
          </div>

          {/* Trust badges */}
          <div className="flex items-center justify-center gap-1.5 text-[10px] font-medium text-cream-200/50 mt-6" data-id="element-156">
            <span data-id="element-157">🔒 Pago seguro</span>
            <span className="text-gold-300/30" data-id="element-158">·</span>
            <span data-id="element-159">⚡ Descarga inmediata</span>
            <span className="text-gold-300/30" data-id="element-160">·</span>
            <span data-id="element-161">🛡️ Garantía de 7 días</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}